import React from 'react'
import { View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { StyleService, useStyleSheet } from '@src/style/service'
import { ContentLoader, Rect } from '@src/components/ContentLoader'
import { NavigationContainer } from '@src/screens/Common/containers'
import { ScrollViewWithFade } from '@src/components/ScrollViewWithFade'

export const CheckoutLoadingContent = () => {
  const styles = useStyleSheet(themedStyles)
  const insets = useSafeAreaInsets()

  return (
    <NavigationContainer title="Checkout">
      <ScrollViewWithFade
        style={styles.container}
        scrollViewStyle={[styles.contentContainer, { paddingBottom: insets.bottom + 16 }]}
      >
        <View style={styles.content}>
          <View style={styles.loaderContainer}>
            <ContentLoader variant="card">
              <Rect x="0" y="0" width="140" height="17" rx="4" ry="4" />
              <Rect x="0" y="25" width="75%" height="13" rx="4" ry="4" />
              <Rect x="0" y="42" width="45%" height="13" rx="4" ry="4" />
              <Rect x="90%" y="20" width="10%" height="18" rx="4" ry="4" />

              <Rect x="0" y="95" width="45%" height="17" rx="4" ry="4" />
              <Rect x="83%" y="95" width="17%" height="17" rx="4" ry="4" />

              <Rect x="0" y="166" width="50%" height="18" rx="4" ry="4" />

              <Rect x="0" y="200" width="100%" height="2" rx="0" ry="0" />

              <Rect x="0" y="216" width="40%" height="17" rx="4" ry="4" />
              <Rect x="88%" y="216" width="12%" height="17" rx="4" ry="4" />

              <Rect x="0" y="250" width="30%" height="17" rx="4" ry="4" />
              <Rect x="91%" y="250" width="9%" height="17" rx="4" ry="4" />

              <Rect x="0" y="284" width="55%" height="17" rx="4" ry="4" />
              <Rect x="88%" y="284" width="12%" height="17" rx="4" ry="4" />
            </ContentLoader>
          </View>
        </View>
      </ScrollViewWithFade>
    </NavigationContainer>
  )
}

const themedStyles = StyleService.create({
  container: {
    flex: 1,
    backgroundColor: 'theme.background',
  },
  contentContainer: {
    flexGrow: 1,
  },
  content: {
    padding: 16,
  },
  loaderContainer: {
    height: 328,
  },
})
